/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The type of the discount, either "percentage" or "fixed".
 */
export const DiscountType = {
  Percentage: "percentage",
  Fixed: "fixed",
} as const;
/**
 * The type of the discount, either "percentage" or "fixed".
 */
export type DiscountType = ClosedEnum<typeof DiscountType>;

/** @internal */
export const DiscountType$inboundSchema: z.ZodNativeEnum<typeof DiscountType> =
  z.nativeEnum(DiscountType);
/** @internal */
export const DiscountType$outboundSchema: z.ZodNativeEnum<typeof DiscountType> =
  DiscountType$inboundSchema;
